import React from 'react';
import { Glyphicon, NavItem, Nav, Modal } from 'react-bootstrap';
import { Button } from '../../form/FormControls.jsx';
import { loadDealCopy } from '@/store/allaround.store';
import { clearLink } from './store/deal.store';
import { push } from 'react-router-redux';
import { List } from 'immutable';
import { connect } from 'react-redux';
import { Audit } from './audit/Audit.jsx';
import RoleConfigFilter from '../../auth/RoleConfigFilter.jsx';
import AvailableSince, { VERSIONS } from '@/util/version';
import { takeLock } from '@/store/collaboration.js';
import trash from '../../../../style/trash.png';
import duplicate from '../../../../style/duplicate.png';
import audit from '../../../../style/audit.png';
import { userHasLock } from '../../../util/util';

class DealHeader extends React.Component {
  constructor(props) {
    super(props);
    this.dealExport = this.dealExport.bind(this);
    this.state = { showTakeLockModal: false };
  }

  componentWillReceiveProps(props) {
    if (props.dealCopy && props.dealCopy.get('dealType') == props.dealType) {
      this.props.navigateToDealCopyCreation();
    }
  }

  dealExport() {
    window.location =
      `/api/report/export/dealExport?type=${this.props.dealType}&id=${this.props.id}`;
  }
  takeLock = () => {
    this.handleCloseTakeLockModal();
    this.props.takeLock();
  }

  handleCloseTakeLockModal = () => this.setState({ showTakeLockModal: false });


  handleShowTakeLockModal = () => {
    if (!userHasLock(this.props.dealType, this.props.id)) {
      this.setState({ showTakeLockModal: true });
    }
  }

  render() {
    const { props } = this;
    return (
      <span>
        <Modal
          show={this.state.showTakeLockModal}
          onHide={this.handleCloseTakeLockModal}
        >
          <Modal.Body>
            <div>{props.lock ?
              props.lock.get('owner') : 'Another user'
            } is currently editing the deal, are you sure you want to take over the lock?</div>
            <div><b>All unsaved changes done by this user will be lost!</b></div>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.takeLock}>Yes</Button>
            <Button onClick={this.handleCloseTakeLockModal}>No</Button>
          </Modal.Footer>
        </Modal>
        <div className="second-nav-bar deal-header">
          <Nav
            pullLeft className={`${props.hidden ?
              'deal-label-hidden' : ''} deal-buttons`}
            style={{ display: 'flex', marginLeft: 121 }}
          >
            <NavItem
              onClick={props.onNameClick ? props.onNameClick : () => ({})}
              className={props.nameClass}
            >
              <div className={'transition-deal-button'}>{props.name}</div>
            </NavItem>
            {props.tabs}
          </Nav>
          <Nav pullRight bsStyle="pills" className="navbar-always-float">
            <div className={'deal-filters'}>
              {props.lock && !userHasLock(this.props.dealType, this.props.id)
                ? <NavItem>
                  <Button
                    bsStyle="link"
                    className="btn-link-no-underline-on-hover"
                    style={{ padding: '2px 10px 4px', color: 'white' }}
                    onClick={this.handleShowTakeLockModal}
                  >
                    <Glyphicon
                      glyph="lock"
                      title={`Locked by ${props.lock.get('owner', '')}` +
                  ` at ${new Date(props.lock.get('timeOfLocking'))}`}
                    />
                  </Button>
                </NavItem>
                : ''}
              <AvailableSince version={VERSIONS.Orithia}>
                <NavItem>
                  <Button
                    id="dealExport"
                    className="deal-actions"
                    onClick={this.dealExport}
                    style={{ marginRight: 7 }}
                  >
                DOCX
                  </Button>
                </NavItem>
              </AvailableSince>
              {props.id &&
                <NavItem>
                  <RoleConfigFilter permissions={['audit']}>
                    <AvailableSince version={VERSIONS.VasyaFinal}>
                      <Audit
                        group={{
                          deal: {
                            entity: this.props.deal,
                            module: this.props.dealType,
                          },
                          allProducts: {
                            entities: this.props.deal.get('products', new List()),
                            module: 'compositeproduct',
                          },
                          loadingPorts: {
                            entities: this.props.deal.get('vesselLoadingPorts', new List()),
                            module: 'port',
                            prefix: 'L',
                          },
                          dischargePorts: {
                            entities: this.props.deal.get('vesselDischargePorts', new List()),
                            module: 'port',
                            prefix: 'D',
                          },
                        }}
                        selectedEntityString={`${this.props.dealType}#${this.props.deal.get('id')}`}
                        title="Deal audit"
                        buttonStyle={{ float: 'right' }}
                      >
                        <img src={audit} className={'audit-icon'} alt={'Audit'} />
                        Audit
                      </Audit>
                    </AvailableSince>
                  </RoleConfigFilter>
                </NavItem>
              }
              {!props.disabled && props.id && props.allowDuplicate && !props.hidden ?
                <NavItem>
                  <RoleConfigFilter
                    permissions={this.props.dealType == 'transport' ?
                      ['myTransports#2', 'allTransports#2', 'transportsAssignResponsible']
                      :
                      ['myDeals#2', 'allDeals#2', 'dealsAssignResponsible']}
                  >
                    <Button
                      id="duplicateDeal"
                      bsStyle="link"
                      className="btn-link-no-underline-on-hover"
                      onClick={props.loadDealCopy}
                      disabled={props.saving}
                      style={{ margin: 0 }}
                    >
                      <div>
                        <img
                          className={'trash-icon'}
                          src={duplicate}
                          alt={'Duplicate'}
                          title={'Duplicate'}
                        />
                      Duplicate
                      </div>
                    </Button>
                  </RoleConfigFilter>
                </NavItem>
                :
                ''}
              {!props.disabled && props.id && props.allowDelete ?
                <NavItem>
                  <RoleConfigFilter
                    permissions={this.props.dealType == 'transport' ?
                      ['myTransports#3', 'allTransports#3']
                      :
                      ['myDeals#3', 'allDeals#3']}
                  >
                    <Button
                      id="deleteDeal"
                      bsStyle="link"
                      className="btn-link-no-underline-on-hover"
                      onClick={props.openModal}
                      disabled={props.saving}
                      style={{ marginLeft: 0 }}
                    >
                      {props.hidden ?
                        <div><Glyphicon glyph="repeat" /> Restore</div>
                        :
                        <div>
                          <img
                            className={'trash-icon'} src={trash} alt={'Delete'} title={'Delete'}
                          />
                        Delete
                        </div>
                      }
                    </Button>
                  </RoleConfigFilter>
                </NavItem>
                :
                ''}
              <NavItem>
                <Button
                  id="dealCancel"
                  className="deal-actions"
                  onClick={props.cancel}
                  style={{ marginRight: 7 }}
                  disabled={props.saving}
                >
              Cancel
                </Button>
              </NavItem>
              {!props.disabled ?
                <RoleConfigFilter
                  permissions={this.props.dealType == 'transport' ?
                    ['myTransports#2', 'allTransports#2', 'transportsAssignResponsible']
                    :
                    ['myDeals#2', 'allDeals#2', 'dealsAssignResponsible']}
                >
                  <NavItem>
                    <Button
                      id="dealSave"
                      className="deal-actions"
                      bsStyle="primary"
                      onClick={props.onFromSubmitHandler}
                      style={{ width: 71 }}
                      disabled={props.saving}
                    >
                  Save
                    </Button>
                  </NavItem>
                </RoleConfigFilter>
                : ''}
            </div>
          </Nav>
        </div>
      </span>
    );
  }
}


DealHeader.propTypes = {
  name: React.PropTypes.oneOfType(
    [React.PropTypes.object,
      React.PropTypes.string]),
  id: React.PropTypes.number,
  lock: React.PropTypes.object,
  disabled: React.PropTypes.bool,
  openModal: React.PropTypes.func,
  dealType: React.PropTypes.string,
  dealCopy: React.PropTypes.object,
  loadDealCopy: React.PropTypes.func,
  navigateToDealCopyCreation: React.PropTypes.func,
  hidden: React.PropTypes.bool,
  cancel: React.PropTypes.func,
  onFromSubmitHandler: React.PropTypes.func,
  saving: React.PropTypes.bool,
  nameStyle: React.PropTypes.object,
  tabsStyle: React.PropTypes.object,
  allowDelete: React.PropTypes.bool,
  allowDuplicate: React.PropTypes.bool,
  deal: React.PropTypes.object,
  tabs: React.PropTypes.oneOfType(
    [React.PropTypes.object,
      React.PropTypes.array]),
  takeLock: React.PropTypes.func,
};

export default connect(state => ({
  saving: state.getIn(['allaround', 'saving'], false),
  dealCopy: state.getIn(['allaround', 'dealCopy']),
}),
(dispatch, props) => ({
  loadDealCopy() {
    loadDealCopy(dispatch, props.dealType, props.id);
  },
  navigateToDealCopyCreation() {
    clearLink(dispatch);
    dispatch(push(`/deals/${props.dealType}/new`));
  },
  takeLock() {
    takeLock(dispatch, props.dealType, props.id);
  },
}))(DealHeader);
